module.exports = __webpack_public_path__ + "static/media/5.b3fbe283.jpg";